module.exports = __webpack_public_path__ + "static/media/front.bbf8844d.svg";